import ProgressBar from "../../../app/universalComponents/ProgressBar";
import SectionLabel from "../../../app/universalComponents/SectionLabel";
import ErrorState from "../../../app/universalComponents/ErrorState";
import { palette } from "../../../app/utils/palette";

export default function InventoryBreakdownWidget({ ticketTypes }) {
  const safeTicketTypes = Array.isArray(ticketTypes)
    ? ticketTypes.filter(Boolean)
    : [];

  return (
    <article className="flex flex-col">
      <SectionLabel>Inventory</SectionLabel>

      <div className="space-y-4 rounded-sm border p-4">
        {safeTicketTypes.length === 0 ? (
          <ErrorState>
            You don't have any tickets to sell yet.
          </ErrorState>
        ) : (
          safeTicketTypes.map((ticketType, index) => {
            const sold = Number(ticketType?.sold ?? 0);
            const rawMax = ticketType?.max;
            const max = rawMax == null ? null : Number(rawMax);

            const hasLimitedInventory = Number.isFinite(max) && max > 0;

            const percentage = hasLimitedInventory
              ? Math.round((sold / max) * 100)
              : null;

            return (
              <div
                key={ticketType?.id ?? `${ticketType?.name ?? "ticket"}-${index}`}
                className="space-y-2"
              >
                <div className="flex justify-between gap-4">
                  <div className="shrink-0">
                    <p className="truncate text-sm font-semibold">{ticketType?.name ?? "Unnamed ticket"}</p>
                    <p className="text-xs">{hasLimitedInventory
                        ? `${sold} of ${max} sold`
                        : `${sold} sold`}
                    </p>
                  </div>

                  <div className="shrink-0 text-right">
                    <p className="text-sm">{hasLimitedInventory 
                        ? `${percentage}%` 
                        : "Unlimited"}
                    </p>
                    <p className="text-xs text-gray-500">  {hasLimitedInventory && `${max - sold} remaining`}</p>
                  </div>
                </div>

                <ProgressBar
                  animate
                  value={hasLimitedInventory ? sold : undefined}
                  max={hasLimitedInventory ? max : undefined}
                  barColor={palette[index % palette.length]}
                />
              </div>
            );
          })
        )}
      </div>
    </article>
  );
}